import { useState } from 'react';
import axios from 'axios';

const API = '/api';

const emptyForm = {
  date: '',
  ticker: '',
  description: '',
  type: 'buy',
  assetClass: 'stock',
  units: '',
  pricePerUnit: '',
  brokerage: '0',
  currency: 'AUD',
  notes: ''
};

function InvestmentForm({ onSaved, editData, onCancel }) {
  const [form, setForm] = useState(editData ? {
    ...editData,
    date: editData.date ? new Date(editData.date).toISOString().split('T')[0] : ''
  } : emptyForm);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const units = parseFloat(form.units);
    const pricePerUnit = parseFloat(form.pricePerUnit);
    const brokerage = parseFloat(form.brokerage) || 0;
    const amount = ['buy', 'withdrawal'].includes(form.type)
      ? -((units * pricePerUnit) + brokerage)
      : (units * pricePerUnit) - brokerage;

    const payload = {
      ...form,
      units,
      pricePerUnit,
      brokerage,
      amount,
      date: new Date(form.date).toISOString()
    };

    if (editData) {
      await axios.put(`${API}/investments/${editData.id}`, payload);
    } else {
      await axios.post(`${API}/investments`, payload);
    }
    onSaved();
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-grid">
        <div className="form-group">
          <label>Date</label>
          <input type="date" name="date" value={form.date} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Ticker / Symbol</label>
          <input type="text" name="ticker" value={form.ticker} onChange={handleChange} required placeholder="e.g. AAPL, BTC" />
        </div>
        <div className="form-group">
          <label>Asset Class</label>
          <select name="assetClass" value={form.assetClass} onChange={handleChange}>
            <option value="stock">Stock</option>
            <option value="property">Property</option>
          </select>
        </div>
        <div className="form-group">
          <label>Type</label>
          <select name="type" value={form.type} onChange={handleChange}>
            <option value="buy">Buy</option>
            <option value="sell">Sell</option>
            <option value="dividend">Dividend</option>
            <option value="deposit">Deposit</option>
            <option value="withdrawal">Withdrawal</option>
          </select>
        </div>
        <div className="form-group">
          <label>Units / Quantity</label>
          <input type="number" name="units" value={form.units} onChange={handleChange} step="any" required />
        </div>
        <div className="form-group">
          <label>Price per Unit</label>
          <input type="number" name="pricePerUnit" value={form.pricePerUnit} onChange={handleChange} step="any" required />
        </div>
        <div className="form-group">
          <label>Brokerage / Fees</label>
          <input type="number" name="brokerage" value={form.brokerage} onChange={handleChange} step="any" />
        </div>
        <div className="form-group">
          <label>Currency</label>
          <select name="currency" value={form.currency} onChange={handleChange}>
            <option value="AUD">AUD</option>
            <option value="USD">USD</option>
          </select>
        </div>
        <div className="form-group">
          <label>Description</label>
          <input type="text" name="description" value={form.description} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Notes</label>
          <input type="text" name="notes" value={form.notes} onChange={handleChange} />
        </div>
      </div>
      <div className="form-actions">
        <button type="submit" className="btn-primary">{editData ? 'Update' : 'Add Transaction'}</button>
        {onCancel && <button type="button" className="btn-cancel" onClick={onCancel}>Cancel</button>}
      </div>
    </form>
  );
}

export default InvestmentForm;